import SpecialistSessionReviewAPI from "api/SpecialistSessionReviewAPI";
import useFetchData from "hooks/useFetchData";

export default function useSpecialistSessionReviewsAny( params: SpecialistSessionReviewGETPaginatedParams = {}) {
   return useFetchData({
      APIMethod: SpecialistSessionReviewAPI.getAllAny,
      params: [ params ],
      debounce: true,
      clear_data_on_update: true
   })
}